import { makeStyles } from "tss-react/mui"

type StyleProps = Readonly<{ heightPercent: number }>

const useStyles = makeStyles<StyleProps>()((theme, { heightPercent }) => ({
    bar: {
        width: "1.5rem",
        height: `${heightPercent}%`,
        minHeight: ".5rem",
        borderRadius: ".375rem .375rem 0 0",
        backgroundColor: theme.palette.tailwind.teal[200],
        transition: theme.transitions.create(["height", "background-color"], {
            duration: theme.transitions.duration.shorter,
        }),
    },
    barCurrent: {
        backgroundColor: theme.palette.tailwind.teal[500],
    },
    barSelected: {
        backgroundColor: theme.palette.tailwind.teal[700],
    },
    barEmpty: {
        visibility: "hidden",
    },
}))

type Props = Readonly<{
    heightPercent: number
    isCurrent: boolean
    isSelected: boolean
    isEmpty: boolean
}>

export function OccupancyHourBar({ heightPercent, isCurrent, isSelected, isEmpty }: Props) {
    const { classes, cx } = useStyles({ heightPercent })

    return (
        <div
            className={cx(
                classes.bar,
                isCurrent && classes.barCurrent,
                isSelected && classes.barSelected,
                isEmpty && classes.barEmpty,
            )}
        />
    )
}
